"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosB2BInvoiceCreateInputSchema = exports.APosB2BInvoiceSchema = exports.APosB2BInvoiceItemSchema = exports.APosB2BInvoiceStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
const b2b_customer_schema_1 = require("./b2b-customer.schema");
exports.APosB2BInvoiceStatusSchema = zod_1.z.enum([
    'draft', 'sent', 'partially_paid', 'paid', 'overdue', 'cancelled', 'void',
]);
exports.APosB2BInvoiceItemSchema = zod_1.z.object({
    lineId: id_schema_1.EntityIdSchema,
    variantId: id_schema_1.EntityIdSchema,
    displayName: zod_1.z.string().min(1),
    sku: zod_1.z.string().optional(),
    quantity: zod_1.z.number().int().positive(),
    unitPrice: zod_1.z.number().nonnegative(),
    discount: zod_1.z.number().nonnegative().default(0),
    lineTotal: zod_1.z.number().nonnegative(),
    taxRate: zod_1.z.number().min(0).max(1).default(0),
    taxAmount: zod_1.z.number().nonnegative().default(0),
});
exports.APosB2BInvoiceSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    invoiceId: id_schema_1.EntityIdSchema,
    invoiceNumber: zod_1.z.string().min(1),
    b2bCustomerId: id_schema_1.EntityIdSchema,
    customerName: zod_1.z.string().min(1),
    locationId: id_schema_1.EntityIdSchema,
    orderId: id_schema_1.EntityIdSchema.optional(),
    items: zod_1.z.array(exports.APosB2BInvoiceItemSchema).min(1),
    subtotal: zod_1.z.number().nonnegative(),
    totalDiscount: zod_1.z.number().nonnegative().default(0),
    taxTotal: zod_1.z.number().nonnegative().default(0),
    shippingCost: zod_1.z.number().nonnegative().default(0),
    grandTotal: zod_1.z.number().nonnegative(),
    amountPaid: zod_1.z.number().nonnegative().default(0),
    amountDue: zod_1.z.number().nonnegative(),
    paymentTerms: b2b_customer_schema_1.APosB2BPaymentTermsSchema,
    dueDate: zod_1.z.number(),
    status: exports.APosB2BInvoiceStatusSchema.default('draft'),
    sentAt: zod_1.z.number().optional(),
    paidAt: zod_1.z.number().optional(),
    notes: zod_1.z.string().max(2000).optional(),
    createdBy: id_schema_1.EntityIdSchema,
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosB2BInvoiceCreateInputSchema = zod_1.z.object({
    b2bCustomerId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    orderId: id_schema_1.EntityIdSchema.optional(),
    items: zod_1.z.array(zod_1.z.object({
        variantId: id_schema_1.EntityIdSchema,
        displayName: zod_1.z.string().min(1),
        sku: zod_1.z.string().optional(),
        quantity: zod_1.z.number().int().positive(),
        unitPrice: zod_1.z.number().nonnegative(),
        discount: zod_1.z.number().nonnegative().optional(),
        taxRate: zod_1.z.number().min(0).max(1).optional(),
    })).min(1),
    shippingCost: zod_1.z.number().nonnegative().optional(),
    paymentTerms: b2b_customer_schema_1.APosB2BPaymentTermsSchema,
    dueDate: zod_1.z.number(),
    notes: zod_1.z.string().max(2000).optional(),
});
//# sourceMappingURL=b2b-invoice.schema.js.map